<template>
  <div class="row mailbox-settings-office-hours-day">
    <div class="col-6">
      <el-form-item
        :label="index === 0 ? 'Day' : ''"
        :prop="`listDays[${index}].isOpen`"
      >
        <dd-checkbox
          v-model="day.isOpen"
          :disabled="disabled"
          dd-size="medium"
        >
          {{ day.name }}
          <img
            v-if="day.name === 'Saturday' || day.name === 'Sunday'"
            src="./img/beach.png"
            srcset="
              ./img/beach.png    1x,
              ./img/beach@2x.png 2x,
              ./img/beach@3x.png 3x
            "
          >
        </dd-checkbox>
      </el-form-item>
    </div>
    <div class="col-3">
      <el-form-item
        ref="openTime"
        :label="index === 0 ? 'Open Time' : ''"
        :prop="`listDays[${index}].openTime`"
      >
        <time-picker
          v-model="day.openTime"
          :disabled="!day.isOpen || disabled"
          :placeholder="placeholder"
        />
      </el-form-item>
    </div>
    <div class="col-3">
      <el-form-item
        :label="index === 0 ? 'Close Time' : ''"
        :prop="`listDays[${index}].closeTime`"
      >
        <time-picker
          v-model="day.closeTime"
          :disabled="!day.isOpen || disabled"
          :placeholder="placeholder"
        />
      </el-form-item>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { IOfficeHourDay } from '@/api/types/response.types'

export default defineComponent({
  name: 'MailboxSettingsOfficeHoursDay',

  props: {
    day: {
      type: Object as () => IOfficeHourDay,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    placeholder(): string {
      return this.day.isOpen ? 'Select time' : 'Closed'
    },
  },

  watch: {
    'day.isOpen'(value) {
      if (value) {
        this.day.openTime = !this.day.openTime ? '9:00am' : this.day.openTime
        this.day.closeTime = !this.day.closeTime ? '5:00pm' : this.day.closeTime
      } else {
        this.day.openTime = null
        this.day.closeTime = null
      }
    },
  },
})
</script>


<style lang="scss" scoped>
.mailbox-settings-office-hours-day {
  position: relative;
  margin-bottom: 13px;

  &:not(:last-child) {
    &::after {
      position: absolute;
      right: 15px;
      bottom: 0;
      left: 15px;
      height: 1px;
      content: '';
      background-color: $silver-two;
    }
  }

  .el-form-item {
    margin-bottom: 4px;
  }

  :deep(.el-checkbox__label) {
    font-size: 16px;
    line-height: 23px;
  }
}
</style>
